import { Money } from '@ap/interface-bspc-core';
import { Assumption, MortgageDetail } from '@ap/ap-interface-apix-hypotheken-berekening';

export class MortgageDetailBuilder {
    private amount: Money;
    private netMonthlyAmount: Money;
    private grossMonthlyAmount: Money;
    private assumption: Assumption;

    withAmount(amount: Money): this {
        this.amount = amount;
        return this;
    }

    withNetMonthlyAmount(netMonthlyAmount: Money): this {
        this.netMonthlyAmount = netMonthlyAmount;
        return this;
    }

    withGrossMonthlyAmount(grossMonthlyAmount: Money): this {
        this.grossMonthlyAmount = grossMonthlyAmount;
        return this;
    }

    withAssumption(assumption: Assumption): this {
        this.assumption = assumption;
        return this;
    }

    build(): MortgageDetail {
        return {
            amount: this.amount,
            net_monthly_amount: this.netMonthlyAmount,
            gross_monthly_amount: this.grossMonthlyAmount,
            assumption: this.assumption
        } as MortgageDetail;
    }
}

export const aMortgage = new MortgageDetailBuilder();
